module.exports={
  "climate-change": {
    "climate-change-issue-1": {
      "climate-change-issue-1-answer-3": [
        {
          "slug": "kevin-de-leon",
          "quote": "First, we must be willing to enforce rationing so that the pain of a drought is not all on the backs of our poorest residents. We also need to encourage voluntary conservation, and make it easier for Angelenos to conserve.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "Encourage voluntary rationing and institute rationing.",
          "date": ""
        }
      ],
      "climate-change-issue-1-answer-4": [
        {
          "slug": "craig-greiwe",
          "quote": "We need to focus on increasing supply, not asking people to cut back, when 80%+ of water goes to Agriculture, not individuals.",
          "date": ""
        },
        {
          "slug": "alex-gruenenfelder",
          "date": ""
        }
      ],
      "climate-change-issue-1-answer-2": [
        {
          "slug": "gina-viola",
          "date": ""
        }
      ]
    },
    "climate-change-issue-2": {
      "climate-change-issue-2-answer-4": [
        {
          "slug": "karen-bass",
          "quote": "As Mayor, I will transform our streets to become safer and more walkable – and will champion mobility options so that walking, biking, and transit are accessible to all communities… And I’ll expand our EV network, and work to electrify our bus fleet.",
          "date": ""
        }
      ],
      "climate-change-issue-2-answer-1": [
        {
          "slug": "kevin-de-leon",
          "quote": "One of the first things we can do is to convert all city transportation — Metro buses, light rail, etc. — to electric. Though some city CNG (“Clean” Natural Gas) are touted as lower emissions, there is no truly “clean” natural gas. To eliminate tailpipe emissions, we need to completely electrify our transit system.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "The city’s fleet of cars, trucks, police cruisers, and buses are all opportunities for electrification and hydrogen power. We must move as quickly as possible to convert and replace the City’s fleet to electric and hydrogen-powered fleets.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "The biggest opportunity to lower emissions is to target and require cars, trucks, buses, trains, ships and planes to use zero emission fuels in LA. I will convert Metro’s 2,000 buses, hundreds of LADOT buses and thousands of LA City fleets to zero emission fuels. We will phase out the use of fossil fuels in vessels that enter the Ports of LA. We will electrify cargo cranes, phase out the use of carbon generating trucks that enter the Ports of LA.",
          "date": ""
        }
      ],
      "climate-change-issue-2-answer-3": [
        {
          "slug": "craig-greiwe",
          "quote": "Building a more affordable city where people can live near where they work takes more cars off the road than any other initiative.",
          "date": ""
        }
      ],
      "climate-change-issue-2-answer-2": [
        {
          "slug": "alex-gruenenfelder",
          "quote": "Expanding green, safe, and reliable public transit is necessary to solve our city's transportation woes.",
          "date": ""
        },
        {
          "slug": "gina-viola",
          "quote": "We must reduce our over dependence on car travel in this city. It is time for us to invest in our public transportation systems and make them truly public by making them free! By properly funding and investing in public transit, Los Angeles can become a healthier city.",
          "date": ""
        }
      ]
    }
  },
  "homelessness": {
    "homelessness-issue-1": {
      "homelessness-issue-1-answer-2": [
        {
          "slug": "karen-bass",
          "quote": "I supported the intent of the anti-camping ordinance passed by the City Council and believe it is unacceptable for homeless encampments to exist near schools and child care centers. What I have a problem with is its district by district, encampment by encampment approach. We need coordinated, citywide leadership to solve this problem, and we need to ensure that housing and services are available for homeless individuals because what I will never accept is simply moving an encampment from one neighborhood to another. That’s not a solution – it’s just passing the buck.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "It is not progressive, nor humane, to leave Angelenos to live and die on the streets of our city. That’s why I’ve moved quickly to create enough shelter to house 80% of the homeless in Northeast Los Angeles. The 41.18 Municipal Code only works as-is if there are adequate housing opportunities available, which is why I’ve introduced my 25x25 plan – unanimously supported by the L.A. City Council – to build 25,000 units of housing in the next 3 years.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "41.18 is a poorly-written partial band-aid with no real solution. We cannot have encampments, but we must have places for people to go. We must regulate and enforce public space, but we must have places for people to go and services they are required to receive.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "I will build 30,000 shelter beds in 300 days with supported services to get people off our streets and provide them with the help they need to get back on their feet. I will also enforce 41.18 to keep people from turning our parks, sidewalks, and bus shelters into encampments.",
          "date": ""
        }
      ],
      "homelessness-issue-1-answer-3": [
        {
          "slug": "alex-gruenenfelder",
          "quote": "The anti-camping law … should be replaced by one that guarantees people in encampments are given access to shelter or housing.",
          "date": ""
        }
      ],
      "homelessness-issue-1-answer-4": [
        {
          "slug": "gina-viola",
          "quote": "It should be repealed. It is a human rights violation.",
          "date": ""
        }
      ],
      "homelessness-issue-1-answer-1": [
        {
          "slug": "mel-wilson",
          "quote": "Should be kept in place.",
          "date": ""
        }
      ]
    },
    "homelessness-issue-2": {
      "homelessness-issue-2-answer-3": [
        {
          "slug": "karen-bass",
          "quote": "This is a complex, multi-faceted problem that requires a multi-pronged, whole of government solution... Nearly 60% of individuals who enter homelessness for the first time cite economic hardship as the primary factor for losing their home. Nearly 50% of unsheltered individuals are either suffering from severe mental illness or substance abuse. 60% of the homeless population are formerly incarcerated individuals who confront barriers to housing and employment because of their backgrounds... Our communities of color are also disproportionately homeless... [And] 1 in 4 homeless youth in LA are former foster youth and 1 in 5 homeless youth identify as LGBTQ.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "The factors that led Angelenos to experience homelessness are as varied as the people themselves, though there are some leading causes. 1) A severe lack of housing stock, specifically affordable housing. 2) A crumbling social safety net, with housing voucher values in the basement and no real mental health or substance abuse services. 3) A city that works for the very wealthy, while leaving the poor to fend for themselves, often unable to pay rent as costs rise. Still others find themselves financially destitute and on the streets due to medical bills or personal trauma.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "L.A. is no different from hundreds of American cities. There are lots of contributing factors from mental health to addiction to rising costs of housing, but the #1 immediate source is \"one bad day,\" one mistake that tips someone into homelessness.",
          "date": ""
        },
        {
          "slug": "alex-gruenenfelder",
          "quote": "A triage of problems: housing costs, addiction, and mental illness.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "Undiagnosed, untreated mental illness, drug addiction, people who cannot survive the high cost of living in L.A., youth who were emancipated out of the foster care program.",
          "date": ""
        }
      ],
      "homelessness-issue-2-answer-1": [
        {
          "slug": "gina-viola",
          "quote": "The history of 20th century U.S. housing policy is wealth building for white people and wealth extraction for Black people in particular and people of color in general. Until we reckon with this fact, we will never eradicate houselessness.",
          "date": ""
        }
      ],
      "homelessness-issue-2-answer-2": [
        {
          "slug": "rick-caruso",
          "quote": "Economic hardship is the #1 cause cited for the newly homeless, and the housing affordability crisis in L.A. and across the state continues to worsen.",
          "date": ""
        }
      ]
    },
    "homelessness-issue-3": {
      "homelessness-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "Homelessness is unquestionably a threat to public safety – it’s unsafe for the housed and the unhoused. The fact of the matter is this: if the tens of thousands of people living in tent encampments lived in houses or apartments instead, all of Los Angeles would feel safer.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "Homelessness is a humanitarian crisis, a public health crisis, and a public safety crisis all-in-one. Leaving tens of thousands of people to live outdoors on our streets and sidewalks is exceptionally dangerous – especially for our unhoused neighbors. In particular women, protected by nothing but a flimsy tent-zipper, are exposed to all manner of violence and sexual assault. Alternatively, we’ve seen janitors and other workers at Union Station attacked by unhoused individuals living with severe mental illnesses.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "Yes. It's unsafe on every level. It's unsanitary, it provides hiding places for criminals, it fosters drug use, and it incentivizes bad behavior for communities.",
          "date": ""
        },
        {
          "slug": "alex-gruenenfelder",
          "quote": "The homelessness crisis makes everyone less safe, including those on the streets. It is impossible to address public safety without addressing homelessness.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "Untreated mental health individuals who are a safety risk to themselves and to the public. Open drug sales and use is contributing to criminal behavior. Drug users are committing crimes on the public and committing crimes on each other. Mentally ill people are a danger to themselves and to the public. Biohazard conditions (used hypodermic needles, methamphetamine, heroin and fentanyl use is a public safety hazard). People living on the streets without proper sanitary receptacles to defecate and urinate on the streets are a health hazard. People living on the streets creates an environment for diseases to grow and spread.",
          "date": ""
        }
      ],
      "homelessness-issue-3-answer-2": [
        {
          "slug": "gina-viola",
          "quote": "It is the most unsafe for the people who have been forced to live on the streets.",
          "date": ""
        }
      ],
      "homelessness-issue-3-answer-3": [
        {
          "slug": "rick-caruso",
          "quote": "I think a significant percentage of our homeless crisis is driven by those who are mentally ill and suffer from substance abuse. Whether they directly make our city less safe is debatable, but they do make people feel less safe outside, at our parks, or walking down the street. We need to get people housed, we need to get them services, and for those who can not make rational decisions for themselves due to mental illness we need a Cares Court now.",
          "date": ""
        }
      ]
    },
    "homelessness-issue-4": {
      "homelessness-issue-4-answer-3": [
        {
          "slug": "karen-bass",
          "quote": "Both, because this problem requires an all-of-the-above approach, and that starts with ensuring the city makes it easier for developers to build… I will consolidate all planning, and building and safety functions in a single unit with only one job: fast-track all affordable housing through the development process.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "The City should be working with all builders to reach our goal of providing enough temporary and permanent housing opportunities to bring our unhoused neighbors indoors. This crisis demands an all-hands-on-deck approach; and with more people falling into homelessness every single day, we need to bring public and private partners together on projects that will bring us closer to our housing goals.",
          "date": ""
        },
        {
          "slug": "alex-gruenenfelder",
          "quote": "We can only build the massive amount of housing our city needs if both the city and private developers work to get the job done.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "Both. We are in a crisis, let's bring every resource to the table and get our unhoused off our streets and back on their feet.",
          "date": ""
        }
      ],
      "homelessness-issue-4-answer-4": [
        {
          "slug": "craig-greiwe",
          "quote": "Housing for the homeless should be a temporary stabilization method. We need to stop thinking we have to house the homeless forever. Some will need permanent support, but most do not. We just need to get most people back on their feet.",
          "date": ""
        }
      ],
      "homelessness-issue-4-answer-1": [
        {
          "slug": "gina-viola",
          "quote": "The city! The public/private partnership has resulted in our tax dollars being transferred to the private sector.",
          "date": ""
        }
      ],
      "homelessness-issue-4-answer-2": [
        {
          "slug": "mel-wilson",
          "quote": "The private sector should build the housing, take the risk for development cost of material and labor. The public sector can agree to a delivery cost and the public sector either buys or leases housing units from the private sector. This will shift the construction risks from the public to the private sector. The private sector can assess the cost, risk and time for delivery and require a reasonable return on their investments for building the housing units. ",
          "date": ""
        }
      ]
    },
    "homelessness-issue-5": {
      "homelessness-issue-5-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "As Mayor, I will cut through red tape, expedite approvals, waive development fees and work with the community to build more permanent and affordable housing.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "Our arcane regulations, insane bureaucracy, and city leaders make it impossible to build any housing, including affordable housing.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "[B]uilding in Los Angeles isn’t just expensive, it’s designed to incentivize building high-cost luxury housing over affordable housing. Los Angeles has one of the longest … processes in the country, with most projects taking upwards of 24 months. This timeline creates massive holding costs for builders and, when combined with fees, labor laws, and environmental review challenges, typical projects get delayed for years.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "The high building and permit fees the city of L.A. charges builders.",
          "date": ""
        }
      ],
      "homelessness-issue-5-answer-3": [
        {
          "slug": "kevin-de-leon",
          "quote": "A lack of leadership with the courage and vision to mandate the inclusion of affordable units in new developments. Additionally, restrictive downzoning under prior city governments has reduced the available space to build affordable housing. As Mayor, I'll reverse both of these trends.",
          "date": ""
        }
      ],
      "homelessness-issue-5-answer-2": [
        {
          "slug": "alex-gruenenfelder",
          "quote": "NIMBYism (the \"Not In My Back Yard\" mentality).",
          "date": ""
        }
      ],
      "homelessness-issue-5-answer-4": [
        {
          "slug": "gina-viola",
          "quote": "The amount of private partners who've become overly involved in the process. I've spoken to developers of low income housing who've told me the difficulty that is had securing the funding from the various income streams that are beholden to private equity firms.",
          "date": ""
        }
      ]
    }
  },
  "policing": {
    "policing-issue-1": {
      "policing-issue-1-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "The LAPD is down hundreds of officers from its authorized force of 9,700. As Mayor, I will return the LAPD to its full authorized force, and provide funding to the Personnel Department to aggressively recruit new officers who are invested in reform and accountability.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "We can make sure our streets, sidewalks, and homes are secure by reaching the LAPD’s currently budgeted size of 9,706 officers. Los Angeles does not need to increase the size of its police force by tens of thousands of officers, as other candidates have proposed, costing taxpayers billions of dollars at a time families are already struggling to put food on the table and keep a roof over their heads.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "I believe that budgeting and adding new officers is a false choice... We need to start by focusing officers on police work, instead of asking them to show up to everything, and remove them from the homelessness response. Only then can we see how many officers we need.",
          "date": ""
        }
      ],
      "policing-issue-1-answer-4": [
        {
          "slug": "alex-gruenenfelder",
          "quote": "I am satisfied with the current amount of LAPD officers, but we must demilitarize the police department and invest in other forms of crisis response.",
          "date": ""
        }
      ],
      "policing-issue-1-answer-3": [
        {
          "slug": "gina-viola",
          "quote": "It should be downsized. Have you seen the response to a person having a mental health crisis? I've routinely witnessed as many as 10 vehicles with 20 officers and even a helicopter respond.",
          "date": ""
        }
      ],
      "policing-issue-1-answer-2": [
        {
          "slug": "rick-caruso",
          "quote": "I will add 1,500 officers to our force before the end of my first term. My administration will apply for every federal and state grant there is and even demand more direct funding from the Biden administration and Governor Newsom to expand and strengthen our police force and ensure they are trained properly and engaged with the communities they serve.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "I will budget for hiring up to 11,000 public safety officers. That public safety core includes hiring 350 mental health experts, hiring community public safety ambassadors (youths and seniors).",
          "date": ""
        }
      ]
    },
    "policing-issue-2": {
      "policing-issue-2-answer-3": [
        {
          "slug": "karen-bass",
          "quote": "I will immediately increase co-response and alternative response teams, like the new CIRCLE initiative, that include mental health, homeless outreach and other specialists who can respond to people in distress, freeing officers to focus on crime. That’s how we maintain the current spending.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "Funding for the LAPD should stay the same.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "We cannot defund the police, but no one knows how much funding they need. We need to put LAPD to work doing just police work, and see how much that costs. There are definitely cost savings we need to put in place that can bring the budget down, but we also need to fully fund the LAPD's work to keep our communities safe.",
          "date": ""
        }
      ],
      "policing-issue-2-answer-2": [
        {
          "slug": "alex-gruenenfelder",
          "quote": "We should reallocate a small amount of the LAPD's budget toward social services, mental healthcare and addiction treatment, and unarmed crisis response.",
          "date": ""
        },
        {
          "slug": "gina-viola",
          "quote": "It should be decreased. This number [16% of city budget] is not inclusive of the LAPD's full budget number of $3.2 billion which is just less than half of the city's unrestricted budget. A budget of this size leaves nothing left to invest in the health and well being of our city in the form of youth development, community development, childcare, healthcare and job training.",
          "date": ""
        }
      ],
      "policing-issue-2-answer-1": [
        {
          "slug": "rick-caruso",
          "quote": "I will restore the LAPD’s budget and expand the number of patrol officers with more hiring, civilianization of non-essential sworn positions, and a commitment to more training and diversified recruitment.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "[The budget should] increase to accommodate 350 mental health experts and community public safety ambassadors.",
          "date": ""
        }
      ]
    },
    "policing-issue-3": {
      "policing-issue-3-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "Los Angeles cannot arrest its way out of crime. It’s not law enforcement’s role to focus on the root causes of crime and violence – community organizations and trained experts can and should be given the resources to do just that. Prevention is better than cure.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "There is no direct correlation between lower crime and higher numbers of officers, as noted by a number of studies. What is more important is how we use our officers. Our LAPD Reserves, for example, are an underutilized resource. Rather than having them direct traffic at the Staples Center, I want to position them in hot spots around the City as an increased deterrent for crime.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "Yes. We need officers to live in the communities they serve, we need to implement the 2015 Community Oriented Policing Report, we need to fully fund a non-violent community engagement force focused on mental health, addiction, and other issues. We need to ensure that people who commit real crimes serve their time, and we need to focus on anti-recidivism efforts so those people don't commit crimes again.",
          "date": ""
        },
        {
          "slug": "alex-gruenenfelder",
          "quote": "The LAPD has a role to play in reducing crime, but investments in anti-poverty programs, treatment for addiction and mental illness, and unarmed crisis response will reduce crime more over time.",
          "date": ""
        },
        {
          "slug": "gina-viola",
          "quote": "Absolutely. Healthy, resourced communities are safe communities.",
          "date": ""
        }
      ],
      "policing-issue-3-answer-2": [
        {
          "slug": "rick-caruso",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "No. Violent crimes are on the rise. People in every part of the city are asking for more public safety.",
          "date": ""
        }
      ]
    },
    "policing-issue-4": {
      "policing-issue-4-answer-1": [
        {
          "slug": "karen-bass",
          "quote": "I have spent my adult life working on police reform, and will continue to do so if elected mayor – by focusing on how to safeguard our communities, preventing the conditions that lead to arrests, and rehabilitating people.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "It's time we had a real conversation about culture change in the LAPD – which starts with training practices in the Academy. As Mayor, I’ll work with the LAPD Chief to make sure every officer is trained to treat all Angelenos with dignity and respect.",
          "date": ""
        },
        {
          "slug": "craig-greiwe",
          "quote": "The Obama Department of Justice put together a bipartisan 2015 Community Oriented Policing Solutions roadmap that showed how to bring crime down, build trust with communities, and bring more fairness to policing while eliminating bias — we should implement that plan wholesale.",
          "date": ""
        },
        {
          "slug": "alex-gruenenfelder",
          "quote": "Racial profiling is a problem in Los Angeles, and we must crack down on and end LAPD use of racial profiling.",
          "date": ""
        },
        {
          "slug": "gina-viola",
          "quote": "I believe that LAPD should be removed entirely from traffic stops.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "quote": "Yes, racial profiling is a problem which is why I want to re-invest in community-based policing so our senior leads and police officers know their community.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "quote": "Hold cops accountable, hire community ambassadors to work with the department. Have communities directly part of community policing deployment.",
          "date": ""
        }
      ]
    },
    "policing-issue-5": {
      "policing-issue-5-answer-2": [
        {
          "slug": "karen-bass",
          "quote": "While I don’t agree with all of the District Attorney’s policies, I do not support the recall – even though his approach has failed to consider some critical elements of public safety. I fundamentally believe that we can have safety and justice at the same time.",
          "date": ""
        },
        {
          "slug": "kevin-de-leon",
          "quote": "While George Gascón and I don’t always see eye-to-eye, the recall process is a gross waste of taxpayer dollars, and should be reserved only for those accused of high crimes; not abused by the very wealthy to serve their own interests.",
          "date": ""
        },
        {
          "slug": "mel-wilson",
          "date": ""
        }
      ],
      "policing-issue-5-answer-3": [
        {
          "slug": "craig-greiwe",
          "quote": "I was the first candidate to call for his removal, as he is not fulfilling his constitutional duties. I believe criminal justice reform is needed, but his work is extreme and makes Angelenos more unsafe while creating a divisive environment.",
          "date": ""
        },
        {
          "slug": "rick-caruso",
          "date": ""
        }
      ],
      "policing-issue-5-answer-1": [
        {
          "slug": "alex-gruenenfelder",
          "date": ""
        },
        {
          "slug": "gina-viola",
          "date": ""
        }
      ]
    }
  }
}